// Import the functions you need from the SDKs you need
import { FirebaseApp, initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfigDev = {
  apiKey: "AIzaSyAEi1un6a1wGv10sh-RF_A6n1keiKw6efQ",
  authDomain: "earlybirdrsvp-dev.firebaseapp.com",
  projectId: "earlybirdrsvp-dev",
  storageBucket: "earlybirdrsvp-dev.firebasestorage.app",
  messagingSenderId: "801631728689",
  appId: "1:801631728689:web:56b713f3b6978b9bda9110",
};

const firebaseConfigPrd = {
  apiKey: "AIzaSyBjxPA7IJjdXvcvCn1Qsr6KWG8yXKejDk8",
  authDomain: "earlybirdrsvp-prd.firebaseapp.com",
  projectId: "earlybirdrsvp-prd",
  storageBucket: "earlybirdrsvp-prd.firebasestorage.app",
  messagingSenderId: "114895341876",
  appId: "1:114895341876:web:2700b464a31c6b60927d61",
};

const firebaseDb = (window as any).firestoreDatabase as string;
let app: FirebaseApp;
switch (firebaseDb) {
  case "firestore-dev":
    app = initializeApp(firebaseConfigDev);
    break;
  case "firestore-prd":
    app = initializeApp(firebaseConfigPrd);
    break;
  default:
    app = initializeApp(firebaseConfigDev);
    break;
}
export const auth = getAuth(app);

const authEmulatorURL = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
if (authEmulatorURL !== "" && authEmulatorURL != null) {
  console.log(`Using local Firebase emulator:"${authEmulatorURL}"`);
  connectAuthEmulator(auth, "http://" + authEmulatorURL);
}
